import { createTheme } from '@mui/material';
import _ from 'lodash';
import { customerThemeOptions, professionalThemeOptions, } from './theme';
import { ThemeDatepicker } from './theme/components/datepicker';
export const professionalThemeOptionsWithDatepicker = _.merge({}, professionalThemeOptions, {
    components: Object.assign({}, ThemeDatepicker),
});
export const customerThemeOptionsWithDatepicker = _.merge({}, customerThemeOptions, {
    components: Object.assign({}, ThemeDatepicker),
});
export const professionalThemeWithDatepicker = createTheme(professionalThemeOptionsWithDatepicker);
export const customerThemeWithDatepicker = createTheme(customerThemeOptionsWithDatepicker);
export const getPartialProfessionalThemeWithDatepicker = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, professionalThemeOptions), { components: _.pick(Object.assign(Object.assign({}, professionalThemeOptions.components), ThemeDatepicker), pickedKeys) }));
export const getPartialCustomerThemeWithDatepicker = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, customerThemeOptions), { components: _.pick(Object.assign(Object.assign({}, customerThemeOptions), ThemeDatepicker), pickedKeys) }));
